import dayjs, { ManipulateType } from "dayjs";

import type { Frequency } from "../../types";

const FREQUENCY_OFFSETS: Record<Frequency, [number, ManipulateType]> = {
  MONTHLY:       [1,  "month"],
  QUARTERLY:     [3,  "month"],
  SEMI_ANNUALLY: [6,  "month"],
  ANNUALLY:      [1,  "year"],
};

const nextRecurrenceDate = (
  startDate: string,
  frequency: Frequency,
  todayDate?: string,
): string | undefined => {
  const hasValue = startDate && frequency;

  if (!hasValue) {
    return undefined;
  }

  const startAtDay = dayjs(startDate).startOf("day");
  const currentAtDay = dayjs(todayDate ?? dayjs().toISOString()).startOf("day");

  const hasInvalidDate = 
    !startAtDay.isValid || 
    !currentAtDay.isValid;

  if (hasInvalidDate) {
    return undefined;
  }

  const isStartDateAlreadyTheNextRecurrence = !startAtDay.isBefore(currentAtDay);
  
  if (isStartDateAlreadyTheNextRecurrence) {
    return startAtDay.format("MM/DD/YYYY");
  }

  const [amount, unit] = FREQUENCY_OFFSETS[frequency];
  
  const monthsInterval = unit === "year" ? amount * 12 : amount;
  const totalMonths = Math.max(0, currentAtDay.diff(startAtDay, "month"));
  const maxIterations = Math.min(5000, Math.ceil(totalMonths / monthsInterval) + 5);

  let candidate = startAtDay;
  for (let i = 0; i < maxIterations; i += 1) {
    candidate = candidate.add(amount, unit);

    const isCandidateOnOrAfterCurrentDate = !candidate.isBefore(currentAtDay);
    
    if (isCandidateOnOrAfterCurrentDate) {
      return candidate.format("MM/DD/YYYY");
    }
  }

  return undefined;
};

export default nextRecurrenceDate;
